// Reexportar el modelo TipoCanal desde domain/model
export type { TipoCanal } from 'src/app/domain/model/tipo-canal/tipo-canal';
import type { TipoCanal } from 'src/app/domain/model/tipo-canal/tipo-canal';
import type { DireccionCursor, PageResponse } from 'src/app/domain/model/common/page-response.dto';

/**
 * Tipo de datos que retorna el backend (columnas de Oracle).
 * Se mapea internamente a TipoCanal en el adaptador HTTP.
 */
export interface TipoCanalBackendResponse {
	nmconsecutivo: number;
	dstexto: string;
	cdvalor?: string;
}

/**
 * Puerto Abstracto: TipoCanalRepository
 * 
 * Define el contrato para operaciones con Tipos de Canal.
 * Migrado del legacy GWT UtilidadesBuscadores.buscarTipoCanal().
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpTipoCanalRepository (adaptador) lo implementa en infraestructura
 */
export abstract class TipoCanalRepository {

	/**
	 * Página de tipos de canal activos, paginada en el servidor con keyset/cursor
	 * (size obligatorio, máximo 100). El total viene en totalElements de la misma respuesta.
	 * El backend interpreta el filtro: número → código exacto; texto → descripción que contiene.
	 * Legacy: UtilidadesBuscadores.buscarTipoCanal() (BusquedaActivity paginado en servidor).
	 * @param filtro Texto de búsqueda (vacío = sin filtro)
	 * @param cursor Cursor opaco de la página actual (null = primera página o LAST)
	 * @param size Tamaño de página
	 * @param direction NEXT | PREVIOUS | LAST
	 */
	abstract buscarPagina(
		filtro: string,
		cursor: string | null,
		size: number,
		direction: DireccionCursor
	): Promise<PageResponse<TipoCanal>>;
}
